// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__6xRmS","resendInfoText":"OnGoingPaymentBox_resendInfoText__UvE-i"};